import * as React from 'react';
import GanttChart from "components/Gantt/gantt.js";

export const PlannerGantt = (
    <div style={{"width":"50%"}}>
        <GanttChart/>
    </div>
);